<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input
              v-model="name"
              type="text"
              class="form-control form-control-sm"
            />
          </div>
          <div class="form-group">
            <div class="d-flex align-items-center">
              <div>
                <input id="checkPool" type="checkbox" v-model="pool" />
              </div>
              <label for="checkPool" class="font-weight-bold mb-0 ml-2"
                >Pool</label
              >
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex align-items-center">
              <div>
                <input id="checkEndose" type="checkbox" v-model="endose" />
              </div>
              <label for="checkEndose" class="font-weight-bold mb-0 ml-2"
                >Endose</label
              >
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex align-items-center">
              <div>
                <input id="checkPrivado" type="checkbox" v-model="privado" />
              </div>
              <label for="checkPrivado" class="font-weight-bold mb-0 ml-2"
                >Privado</label
              >
            </div>
          </div>
          <div class="form-group text-right">
            <button
              class="btn btn-sm btn-outline-success"
              :disabled="loading.crud"
              @click="onNew"
            >
              Nuevo
            </button>
            <button
              class="ml-2 btn btn-sm btn-primary"
              :disabled="loading.crud"
              @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
                <tr class="text-center align-middle">
                  <th style="width: 150px"></th>
                  <th>Nombre</th>
                  <th>Pool</th>
                  <th>Endose</th>
                  <th>Privado</th>
                  <th>UC</th>
                  <th>UM</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in containers.servicios"
                  :key="item.idServicio"
                  class="align-middle text-center"
                >
                  <td>
                    <template v-if="item.origen != 0">
                      <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                      >
                        <span class="fa fa-fw fa-pencil-alt"></span>
                      </button>
                      <button
                        class="btn btn-xs btn-icon btn-light-danger ml-1"
                        @click="onDelete(item)"
                      >
                        <span class="fa fa-fw fa-trash-alt"></span>
                      </button>
                    </template>
                    <button
                      @click="onShowModalServicioTipos(item)"
                      class="btn btn-xs btn-icon btn-light-primary ml-1"
                    >
                      <span class="fa fa-fw fa-list"></span>
                    </button>
                  </td>
                  <td>{{ item.nombre }}</td>
                  <td>{{ item.pool == 1 ? "Sí" : "No" }}</td>
                  <td>{{ item.endose == 1 ? "Sí" : "No" }}</td>
                  <td>{{ item.privado == 1 ? "Sí" : "No" }}</td>
                  <td>{{ item.usuarioCreador }}</td>
                  <td>{{ item.usuarioModif }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <ModalServicioTipos
      v-if="containers.showModalServicioTipos"
      :servicio="containers.servicio"
      :show="containers.showModalServicioTipos"
      @close="containers.showModalServicioTipos = false"
    />
  </div>
</template>
<script>
import ModalServicioTipos from "@/modals/ServicioTipos.vue";

export default {
  components: {
    ModalServicioTipos,
  },
  data() {
    return {
      name: "",
      pool: false,
      endose: false,
      privado: false,
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        servicios: [],
        servicio: null,
        showModalServicioTipos: false,
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/servicios");

    vm.containers.servicios = content.servicios;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        name: String(vm.name).trim(),
        pool: vm.pool ? 1 : 0,
        endose: vm.endose ? 1 : 0,
        privado: vm.privado ? 1 : 0,
        _method: "POST",
      };

      if (!fd.name) {
        return vm.$swal.fire(
          "",
          "Completa los campos obligatorios (*)",
          "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/servicios";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/servicios/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            let findRow = vm.containers.servicios.find(
              (item) => item.idServicio == vm.containers.id
            );

            findRow.nombre = fd.name;
            findRow.pool = fd.pool;
            findRow.endose = fd.endose;
            findRow.privado = fd.privado;
            findRow.usuarioModif = vm.$store.state.user.codigo;
          } else {
            vm.containers.servicios.push({
              nombre: fd.name,
              pool: fd.pool,
              endose: fd.endose,
              privado: fd.privado,
              idServicio: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo,
            });

            vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idServicio;
      vm.name = pItem.nombre;
      vm.pool = pItem.pool == 1 ? true : false;
      vm.endose = pItem.endose == 1 ? true : false;
      vm.privado = pItem.privado == 1 ? true : false;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/servicios/${pItem.idServicio}`)
          .then((response) => {
            let tempRegistros = [...vm.containers.servicios];
            vm.containers.servicios = tempRegistros.filter(
              (item) => item.idServicio != pItem.idServicio
            );
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.name = "";
      vm.pool = false;
      vm.endose = false;
      vm.privado = false;
    },
    onShowModalServicioTipos(pItem) {
      this.containers.servicio = pItem;
      this.containers.showModalServicioTipos = true;
    },
  },
};
</script>
